module.exports = __webpack_public_path__ + "img/audio2.963f8995.png";